import React from 'react';
import { ImageItem } from '../gameConfig';
import './ImageModal.css';

interface ImageModalProps {
  image: ImageItem;
  onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ image, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <img 
          src={image.src} 
          alt={image.description}
          className="modal-image"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/placeholder.jpg';
          }}
        />
        <div className="modal-description">
          {image.description}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;